<template>
	<div class="login">
        <div class="user-name">
        <reg-input v-for="(item, index) in info" :key="index"
        :textpl="item.holderInput"
        :pattern="item.patternInput"
        :value="item.value"
        :valid="true"
        :active="item.active"
         @input="onInputs(index, $event)">
        </reg-input>
        </div>
        <div class="title">Укажите логин и пароль для входа</div>
        <reg-input v-for="(item, index) in email" :key="index+'e'"
        :textpl="item.holderInput"
        :pattern="item.patternInput"
        :value="item.value"
        :valid="true"
        :active="item.active"
         @input="onEmail(index, $event)"
        ></reg-input>
        <div class="help">Укажите Ваш действующий электронный адрес. 
На указанный Вами электронный адрес будет отправлено письмо для подтверждения регистрации.</div>
        <reg-input-pass v-for="(item, index) in pass" :key="index+'p'"
        :textpl="item.holderInput"
        :pattern="item.patternInput"
        :value="item.value"
        :valid="true"
        :active="item.active"
         @input="onPass(index, $event)"></reg-input-pass>
         <div class="help">Пароль должен содержать минимум 6 символов.
Пароль должен состоять из латинских букв или цифр.</div>
        <input type="button" v-show="!loading" :disabled="(doneInf + doneMail + donePass) < 4" value="ЗАРЕГИСТРИРОВАТЬСЯ" @click="onReg">
        <preloader :styles="loaderStyle" v-if="loading"></preloader>
        <div v-if="getError !== ''" class="errorMessage color-red">Возможно введённый EMAIL уже зарегистрирован. Попробуйте ввести другой или авторизуйтесь на сайте.</div>
	</div>
</template>

<script>

import RegInput from '../ui-components/reg-input'
import RegInputPass from '../ui-components/reg-input-pass'
import Loader from '../ui-components/preloader'
import { mapGetters, mapMutations } from 'vuex';
import { setTimeout } from 'timers';
	export default {
		components: {
            'reg-input': RegInput,
            'reg-input-pass':RegInputPass,
            'preloader':Loader
	    },
		props: [],
		data() {
			return {
                info:
                [
                    {
                        holderInput: 'Имя',
                        patternInput: /.+/,
                        value: '',
                        valid:false,
                        active:false
                    },
                    {
                       holderInput: 'Фамилия',
                       patternInput: /.+/,
                       value:'',
                       valid:false,
                       active:false
                    }

                ],
                email: [
                    {
                        holderInput: 'ЭЛЕКТРОННЫЙ АДРЕС',
                        patternInput: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        value: '',
                        valid:false,
                        active:false
                    }
                ],
                pass:[
                    {
                        holderInput: 'Пароль',
                        patternInput: /.+/,
                        value:'',
                        valid:false,
                        active:false
                    },
                    {
                       holderInput: 'Подтверждение пароля',
                       patternInput: /.+/,
                       value:'',
                       valid:false,
                       active:false
                    }
                ],
                doneInf: 0,
                doneMail: 0,
                donePass:0,
                loading:false,
                loaderStyle: {
                    margin:12 + 'px auto',
                    width:50 + 'px',
                    height:50 + 'px'
                }
			};
		},
		computed: {
            ...mapGetters({
                getError:'auth/getErrorMessage'}
            ),
            
        },
        watch: {
            getError: function(value) {
                if(value === 'succes')
                    this.$emit('closeform', false);
            }
        },
		methods: {
            onInputs(index,data) { 
                this.info[index].value = data.value;
                this.info[index].valid = data.completed;
                this.info[index].active = data.activate;
                let done = 0;
                for(let i = 0; i < this.info.length; i++) {
                    if (this.info[i].valid)
                        done++
                }
                return this.doneInf = done;		
            },
            onEmail(index, data) {
                this.email[index].value = data.value;
                this.email[index].valid = data.completed;
                this.email[index].active = data.activate;
                let done = 0;
                for(let i = 0; i < this.email.length; i++) {
                    if (this.email[i].valid)
                                done++
                }
                return this.doneMail = done;
            },
            onPass(index, data) {
                this.pass[index].value = data.value;
                this.pass[index].valid = data.completed;
                this.pass[index].active = data.activate;
                this.pass[0].value === this.pass[1].value ? this.donePass = 1 : this.donePass = 0;
                },
            async onReg() {
                this.loading = true;
                let payload = {User: {Login: this.email[0].value, Password: this.pass[0].value}, Detail: { Name: this.info[0].value, Surname: this.info[1].value , Email: this.email[0].value}};
                await this.$store.dispatch('auth/performLoginAndRegister', payload);
                    this.$store.dispatch('chat/logout');
                    this.$store.dispatch('chat/connectWithCreds', {
				        login: payload.User.Login,
				        password: payload.User.Password
                    });
                    this.loading = false;
            }
        },
        mounted() {
            this.$store.commit('auth/clearError');
        }
	};
</script>

<style lang="less" scoped>
.login {
    margin-top:24px;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.user-name {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 24px;
    margin-bottom: 16px;
    width: 100%;
    border-bottom: 1px solid #324258;
}

.title {
    display: block;
    width: 356px;
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: 0.4px;
    margin-bottom: 8px;
    text-align: left;
    color: #ffffff;
}
.errorMessage {
    width: 356px;
    font-family: Arimo;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    text-align: left;
    color: #adc4e1;
    margin-top: 28px;
}

.help {
    display: block;
    width: 356px;
    font-family: Arimo;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.54;
    letter-spacing: 0.4px;
    text-align: left;
    color: #adc4e1;
    margin-top:8px;
}

input[type="text"]
{
    margin-top:12px;
    width: 356px;
    border-radius: 4px;
    line-height: normal;
    font-family: Arimo;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.4px;
        color: #ffffff;
        background-color: #374b62;
        border: solid 1px #718da8;
        padding: 18px 12px;
        text-align: left;
        outline: none;

        &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: #adc4e1;
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.7;
            text-transform: uppercase;
            letter-spacing: 0.4px;
            opacity: 1; /* Firefox */
        }

        &::-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #adc4e1;
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.7;
            text-transform: uppercase;
            letter-spacing: 0.4px;
        }

        &::-ms-input-placeholder { /* Microsoft Edge */
            color: #adc4e1;
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.7;
            text-transform: uppercase;
            letter-spacing: 0.4px;
        }

        &:hover
        {
            border: solid 1px #cae9ff;
        }

        &:focus
        {
            border: solid 1px #cae9ff;
        }

        &:first-child
        {
            margin-top:20px !important;
        }
    }

    input[type="password"]
    {
        margin-top:12px;
        width: 356px;
        border-radius: 4px;
        background-color: #374b62;
        border: solid 1px #718da8;
        padding: 18px 12px;
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.4px;
        text-align: left;
        color: #adc4e1;
        text-transform: uppercase;
        outline: none;

        &:hover
        {
            border: solid 1px #cae9ff;
        }

        &:focus
        {
            border: solid 1px #cae9ff;
        }
    }

    input[type="button"]
    {
        width: 356px;
        height: 48px;
        border-radius: 4px;
        background-color: #0fd7b7;
        border: none;
        margin-top: 12px;
        color:#374b62;
        cursor: pointer;
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;

        &:disabled
        {
            background-color: #718da8;

            &:hover
            {
              background-color: #718da8;  
            }
        }

        &:hover
        {
            background-color: #00ffd0;
        }
    }


.remember_pass
{
    cursor: pointer;
  font-family: Arimo;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-align: left;
  color: #adc4e1;
  margin-top: 28px;
}

</style>